var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"file-download",attrs:{"href":_vm.formattedUrl,"title":_vm.title,"target":"_blank"}},[(_vm.type.indexOf('pdf') !== -1)?_c('i',[_c('IconPdf')],1):_c('i',[_c('IconFile')],1),_vm._v(" "),_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }